export enum BankAccountContainerType {
  Loading = 'Loading',
  Select = 'Select',
  Done = 'Done',
}
